import React, { Fragment } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ProductSwap from "../features/product-swap/ProductSwap";
import ContactUpdate from "../features/contact-update/ContactUpdate";
import OrderManager from "../features/order-manager/OrderManager";
import { CUSTOMER_MANAGER_TA_CONTACT_UPDATE, CUSTOMER_MANAGER_TA_PRODUCT_SWAP, CUSTOMER_MANAGER_TA_ORDER_MANAGEMENT, hasRole } from "../security/auth";
import AccessDeniedPage from "./AccessDeniedPage";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";

const MainPage = () => {
    const routes = ['/', '/product-swap', '/order-manager'];
    return (
        <BrowserRouter>
            <Route
                path="/"
                render={({ location }) => (
                    <Fragment>
                        <AppBar position="static">
                            <Tabs value={location.pathname}>
                                <Tab label="Contact update" value="/" component={Link} to={routes[0]} />
                                <Tab label="Product swap" value="/product-swap" component={Link} to={routes[1]} />
                                <Tab label="Order management" value="/order-manager" component={Link} to={routes[2]} />
                            </Tabs>
                        </AppBar>
                        <Switch>
                            <Route path={routes[0]} exact render={() => hasRole(CUSTOMER_MANAGER_TA_CONTACT_UPDATE) ? <ContactUpdate /> : <AccessDeniedPage />} />
                            <Route path={routes[1]} exact render={() => hasRole(CUSTOMER_MANAGER_TA_PRODUCT_SWAP) ? <ProductSwap /> : <AccessDeniedPage />} />
                            <Route path={routes[2]} exact render={() => hasRole(CUSTOMER_MANAGER_TA_ORDER_MANAGEMENT) ? <OrderManager /> : <AccessDeniedPage />} />
                        </Switch>
                    </Fragment>
                )}
            />
        </BrowserRouter>
    );
};

export default MainPage;